import React, { useState, useEffect, useRef } from 'react'
import Select, { components } from 'react-select';
import SectionTitle from '../components/section-title'
import Widget from '../components/widget'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { Button, Container, Row, Col, Form, Dropdown } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import { parseCookies } from 'nookies'
import MUIDataTable from 'mui-datatables';
import { useHistory } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import AsyncSelect from 'react-select/async';
import JoditEditor from "jodit-react";
import ReactTooltip from 'react-tooltip';
import { faSignOutAlt, faUserPlus, faHome, faUserLock, faCalendarPlus, faFileInvoice, faCalendarWeek, faCalendarDay, faCalendarAlt, faCalendar, faSearch, faInfo, faFileAlt, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AddInvoice = () => {

    const editor = useRef(null);

    //Setto gli state
    const [allUsers, viewUsers] = useState([{}]);
    const [loading, setLoading] = useState(false);
    const [isCreated, setCreated] = useState(false);
    const [isCreated1, setCreated1] = useState(false);

    const [showSucc, setSucc] = useState('');
    const [user, setUser] = useState(null);
    const [allSettings, viewSettings] = useState('');
    const [allReditectC, viewReditectC] = useState('');
    const [allReditectN, viewReditectN] = useState('');
    const [prewImp, setPrewImp] = useState('');
    const [prewTasse, setPrewTasse] = useState('');
    const [prewAll, setPrewAll] = useState('');
    const [annoFattura, setAnnoFattura] = useState('');
    const [checkCostumers, viewCheck] = useState(false);

    const [showErr, setErr] = useState('');
    const [showErr1, setErr1] = useState('');

    const [allApps, viewApps] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
    const [content, setContent] = useState('');

    const { register, handleSubmit, errors } = useForm();
    const cookies = parseCookies();

    const config = {
        readonly: false,
        height: 'auto',
        placeholder: '',
        language: 'it' // all options from https://xdsoft.net/jodit/doc/
    }

    //Tabella delle entity HTML piu' comuni prodotte da Jodit
    const HTML_ENTITIES = {
        'nbsp': '\u00A0',
        'amp': '&',
        'lt': '<',
        'gt': '>',
        'quot': '"',
        'apos': "'",
        'laquo': '\u00AB',
        'raquo': '\u00BB',
        'ldquo': '"',
        'rdquo': '"',
        'lsquo': '\u2018',
        'rsquo': '\u2019',
        'ndash': '\u2013',
        'mdash': '\u2014',
        'hellip': '\u2026',
        'euro': '\u20AC',
        'deg': '\u00B0',
        'egrave': '\u00E8',
        'eacute': '\u00E9',
        'agrave': '\u00E0',
        'igrave': '\u00EC',
        'ograve': '\u00F2',
        'ugrave': '\u00F9'
    };

    function normalizeDescription(raw) {
        if (raw == null) return '';
        // 0) Converto comunque in stringa
        let s = String(raw);
        // 1) Rimuovo BOM / ZERO WIDTH NO-BREAK SPACE (U+FEFF)
        s = s.replace(/\uFEFF/g, '');
        // 1a) Rimuovo i commenti HTML
        s = s.replace(/<!--[\s\S]*?-->/g, '');
        // 1b) Rimuovo script/style insieme al loro contenuto
        s = s.replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, ' ');
        // 1c) I tag che vanno a capo diventano uno spazio, cosi' <p>a</p><p>b</p> non si incolla in "ab"
        s = s.replace(/<\s*(br|hr)\s*\/?\s*>/gi, ' ');
        s = s.replace(/<\s*\/?\s*(p|div|li|ul|ol|tr|td|th|table|h[1-6]|blockquote|pre|section|article)\b[^>]*>/gi, ' ');
        // 1d) Tolgo tutti i tag rimanenti (span, strong, em, a, ...)
        s = s.replace(/<[^>]*>/g, '');
        // 1e) Decodifico le entity: prima le numeriche (&#160; / &#xA0;), poi quelle con nome
        s = s.replace(/&#(\d+);/g, (m, dec) => {
            const code = parseInt(dec, 10);
            return isNaN(code) ? m : String.fromCharCode(code);
        });
        s = s.replace(/&#[xX]([0-9a-fA-F]+);/g, (m, hex) => {
            const code = parseInt(hex, 16);
            return isNaN(code) ? m : String.fromCharCode(code);
        });
        s = s.replace(/&([a-zA-Z][a-zA-Z0-9]*);/g, (m, name) => {
            const key = name.toLowerCase();
            return Object.prototype.hasOwnProperty.call(HTML_ENTITIES, key) ? HTML_ENTITIES[key] : m;
        });
        // 2) Normalizzo tutti gli spazi "strani" in spazio normale (0x20)
        //    - \s       = whitespace standard
        //    - range    = vari spazi Unicode e zero-width spaces
        s = s.replace(/[\s\u00A0\u1680\u180E\u2000-\u200D\u2028\u2029\u202F\u205F\u2060\u3000]/g, ' ');
        // 3) Collasso spazi multipli in uno solo
        s = s.replace(/ +/g, ' ');
        // 4) Rimuovo caratteri di controllo (non stampabili)
        //    C0 (0x00–0x1F), DEL (0x7F), C1 (0x80–0x9F)
        s = s.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
        // 5) TOLGO tutto ciò che è fuori da Basic Latin + Latin-1 (U+0000–U+00FF)
        s = s.replace(/[^\u0000-\u00FF]/g, '');
        // 6) Trim finale
        return s.trim();
    }

    //Recupero i dati dal db per appuntamenti totali
    useEffect(() => {
        let mounted = true
        const fetch = async () => {
            const allSet = await axios.get(`${window.$apiEndpoint}/invoice/fetch-aliquote-fatture`, {
                headers: {
                    "x-access-token": cookies.token
                }
            });
            try {
                if (mounted) {
                    viewSettings(allSet.data[0])
                }
            } catch (e) {
                console.log(e)
            }
            setLoading(true)
        }
        fetch();
        return () => {
            mounted = false
        }
    }, [cookies.token])

    //Configuro le colonne della tabella
    const columns = ["Data", "Orario di Arrivo", "Orario di Partenza", "Tariffa (€/ora)", "Trattamento"];
    const options = {
        filter: false,
        selectableRows: false,
        filterType: "dropdown",
        rowsPerPage: 4,
        textLabels: {
            body: {
                noMatch: "Spiacenti, nessun record corrispondente trovato",
                toolTip: "Ordinare",
                columnHeaderTooltip: column => `Ordinare per ${column.label}`
            },
            pagination: {
                next: "Pagina successiva",
                previous: "Pagina Precedente",
                rowsPerPage: "Righe per pagina:",
                displayRows: "of",
            },
            toolbar: {
                search: "Cerca",
                downloadCsv: "Scarica CSV",
                print: "Stampa",
                viewColumns: "Vedi Colonne",
                filterTable: "Tabella dei filtri",
            },
            filter: {
                all: "Tutto",
                title: "FILTRI",
                reset: "RIPRISTINA",
            },
            viewColumns: {
                title: "Mostra colonne",
                titleAria: "Mostra / Nascondi colonne tabella",
            },
        }
    };

    const theme = createMuiTheme({
        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',

                },
            },
            MuiIconButton: {
                root: {
                    color: '#424242',

                },
            },
            MuiTableCell: {
                body: {
                    backgroundColor: '#00968817',

                },
            },
            MUIDataTableHeadCell: {
                fixedHeader: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },

            },
            MuiButton: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },

            },
            MuiPaper: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    boxShadow: 'none !important'
                },

            },
            MuiTypography: {
                body2: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },

            },
            MuiMenuItem: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },

            },
            MuiTableCell: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '400',
                },
            },
            MUIDataTableToolbar: {
                hover: {
                    color: '#616161',
                },
            },
        },
    });

    //Recupero i dati dal db
    useEffect(() => {
        let mounted = true
        const fetch = async () => {
            const users = await axios.get(`${window.$apiEndpoint}/appoiments/fetchCApp`, {
                headers: {
                    "x-access-token": cookies.token
                }
            });
            try {
                if (mounted) {
                    viewUsers(users.data)
                }
            } catch (e) {
                console.log(e)
            }
            setLoading(true)
        }
        fetch();
        return () => {
            mounted = false
        }
    }, [cookies.token])

    //Quando Seleziono
    const handleChange = selectedOption => {
        setSelectedOption(selectedOption.value);
        setSelectedOptionLabel("| Cliente: " + selectedOption.label);
    };

    //Bottone settimana
    const week = () => {
        setPrewImp('')
        setPrewTasse('')
        setPrewAll('')

        const id = selectedOption

        //Controllo se il codice cliente è selezionato
        if (!id) {
            return (
                setErr1('Cliente non selezionato'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        //Seleziono cliente
        axios.get(`${window.$apiEndpoint}/appoiments/fetch-apps-week/${id}`, {
            headers: {
                "x-access-token": cookies.token
            }
        }).then(res => {
            viewApps(res.data)
            const risultati = res.data;

            const prev_imponibile = [];
            const prev_tasse = [];
            //Creo la chiamata per recuperare la somma degli appuntamenti

            const app = risultati.map((item, index) => {
                //Setto le variabili sul map
                const IdAppuntamneto = item[5];


                axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(risposta => {

                    const aliquota_intera = (allSettings.aliquota);
                    const aliquota = (allSettings.aliquota / 100);

                    const imponibile = risposta.data[0].NonPagato;
                    const tasse = (risposta.data[0].NonPagato * aliquota);

                    const imponibile_def = Math.round(imponibile * 100) / 100;
                    const tasse_def = Math.round(tasse * 100) / 100;

                    //Creo un array per imponibile e tasse
                    //Eseguo la preview del totale
                    //Eseguo il push dei risultati in un nuovo array
                    prev_imponibile.push(imponibile_def);
                    prev_tasse.push(tasse_def);

                    //Sommo gli Array
                    var sum_prev_imponibile = prev_imponibile.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_imponibile_2 = Math.round(sum_prev_imponibile * 100) / 100;

                    var sum_prev_tasse = prev_tasse.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_tasse_2 = Math.round(sum_prev_tasse * 100) / 100;

                    //Totale preventivo
                    const totaleAllPrev = (sum_prev_imponibile_2 + sum_prev_tasse_2);

                    setPrewImp("Totale Imponibile: " + sum_prev_imponibile_2 + " €");
                    setPrewTasse("Totale Tasse: " + sum_prev_tasse_2 + " €");
                    setPrewAll("Totale Preventivo: " + totaleAllPrev + " €");

                });
            });
        })
    };

    //Bottone mese
    const mese = () => {

        setPrewImp('')
        setPrewTasse('')
        setPrewAll('')

        const id = selectedOption

        //Controllo se il codice cliente è selezionato
        if (!id) {
            return (
                setErr1('Cliente non selezionato'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        //Seleziono cliente
        axios.get(`${window.$apiEndpoint}/appoiments/fetch-apps-mese/${id}`, {
            headers: {
                "x-access-token": cookies.token
            }
        }).then(res => {
            viewApps(res.data)
            const risultati = res.data;
            const prev_imponibile = [];
            const prev_tasse = [];

            //Creo la chiamata per recuperare la somma degli appuntamenti
            const app = risultati.map((item, index) => {
                //Setto le variabili sul map
                const IdAppuntamneto = item[5];

                axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(risposta => {

                    const aliquota_intera = (allSettings.aliquota);
                    const aliquota = (allSettings.aliquota / 100);

                    const imponibile = risposta.data[0].NonPagato;
                    const tasse = (risposta.data[0].NonPagato * aliquota);

                    const imponibile_def = Math.round(imponibile * 100) / 100;
                    const tasse_def = Math.round(tasse * 100) / 100;

                    //Creo un array per imponibile e tasse
                    //Eseguo la preview del totale
                    //Eseguo il push dei risultati in un nuovo array
                    prev_imponibile.push(imponibile_def);
                    prev_tasse.push(tasse_def);

                    //Sommo gli Array
                    var sum_prev_imponibile = prev_imponibile.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_imponibile_2 = Math.round(sum_prev_imponibile * 100) / 100;

                    var sum_prev_tasse = prev_tasse.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_tasse_2 = Math.round(sum_prev_tasse * 100) / 100;
                    //Totale preventivo
                    const totaleAllPrev = (sum_prev_imponibile_2 + sum_prev_tasse_2);

                    setPrewImp("Totale Imponibile: " + sum_prev_imponibile_2 + " €");
                    setPrewTasse("Totale Tasse: " + sum_prev_tasse_2 + " €");
                    setPrewAll("Totale Preventivo: " + totaleAllPrev + " €");
                });
            });
        })
    };

    //Bottone anno
    const anno = () => {
        setPrewImp('')
        setPrewTasse('')
        setPrewAll('')

        const id = selectedOption

        //Controllo se il codice cliente è selezionato
        if (!id) {
            return (
                setErr1('Cliente non selezionato'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        //Seleziono cliente
        axios.get(`${window.$apiEndpoint}/appoiments/fetch-apps-anno/${id}`, {
            headers: {
                "x-access-token": cookies.token
            }
        }).then(res => {
            viewApps(res.data)

            const risultati = res.data;
            const prev_imponibile = [];
            const prev_tasse = [];

            //Creo la chiamata per recuperare la somma degli appuntamenti
            const app = risultati.map((item, index) => {
                //Setto le variabili sul map
                const IdAppuntamneto = item[5];
                axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(risposta => {
                    const aliquota_intera = (allSettings.aliquota);
                    const aliquota = (allSettings.aliquota / 100);

                    const imponibile = risposta.data[0].NonPagato;
                    const tasse = (risposta.data[0].NonPagato * aliquota);

                    const imponibile_def = Math.round(imponibile * 100) / 100;
                    const tasse_def = Math.round(tasse * 100) / 100;

                    //Creo un array per imponibile e tasse
                    //Eseguo la preview del totale
                    //Eseguo il push dei risultati in un nuovo array
                    prev_imponibile.push(imponibile_def);
                    prev_tasse.push(tasse_def);

                    //Sommo gli Array
                    var sum_prev_imponibile = prev_imponibile.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_imponibile_2 = Math.round(sum_prev_imponibile * 100) / 100;

                    var sum_prev_tasse = prev_tasse.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_tasse_2 = Math.round(sum_prev_tasse * 100) / 100;
                    //Totale preventivo
                    const totaleAllPrev = (sum_prev_imponibile_2 + sum_prev_tasse_2);

                    setPrewImp("Totale Imponibile: " + sum_prev_imponibile_2 + " €");
                    setPrewTasse("Totale Tasse: " + sum_prev_tasse_2 + " €");
                    setPrewAll("Totale Preventivo: " + totaleAllPrev + " €");
                });

            });
        })
    };

    //Bottone tutti
    const tutti = () => {
        setPrewImp('')
        setPrewTasse('')
        setPrewAll('')

        const id = selectedOption

        //Controllo se il codice cliente è selezionato
        if (!id) {
            return (
                setErr1('Cliente non selezionato'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        //Seleziono cliente
        axios.get(`${window.$apiEndpoint}/appoiments/fetch-apps-all/${id}`, {
            headers: {
                "x-access-token": cookies.token
            }
        }).then(res => {
            viewApps(res.data)
            const risultati = res.data;
            const prev_imponibile = [];
            const prev_tasse = [];

            //Creo la chiamata per recuperare la somma degli appuntamenti
            const app = risultati.map((item, index) => {
                //Setto le variabili sul map
                const IdAppuntamneto = item[5];

                axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(risposta => {

                    const aliquota_intera = (allSettings.aliquota);
                    const aliquota = (allSettings.aliquota / 100);

                    const imponibile = risposta.data[0].NonPagato;
                    const tasse = (risposta.data[0].NonPagato * aliquota);

                    const imponibile_def = Math.round(imponibile * 100) / 100;
                    const tasse_def = Math.round(tasse * 100) / 100;

                    //Creo un array per imponibile e tasse
                    //Eseguo la preview del totale
                    //Eseguo il push dei risultati in un nuovo array
                    prev_imponibile.push(imponibile_def);
                    prev_tasse.push(tasse_def);

                    //Sommo gli Array
                    var sum_prev_imponibile = prev_imponibile.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_imponibile_2 = Math.round(sum_prev_imponibile * 100) / 100;

                    var sum_prev_tasse = prev_tasse.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_tasse_2 = Math.round(sum_prev_tasse * 100) / 100;

                    //Totale preventivo
                    const totaleAllPrev = (sum_prev_imponibile_2 + sum_prev_tasse_2);

                    setPrewImp("Totale Imponibile: " + sum_prev_imponibile_2 + " €");
                    setPrewTasse("Totale Tasse: " + sum_prev_tasse_2 + " €");
                    setPrewAll("Totale Preventivo: " + totaleAllPrev + " €");
                });
            });
        })
    };

    //Bottone tutti
    const day = () => {

        setPrewImp('')
        setPrewTasse('')
        setPrewAll('')

        const id = selectedOption

        //Controllo se il codice cliente è selezionato
        if (!id) {
            return (
                setErr1('Cliente non selezionato'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        //Seleziono cliente

        axios.get(`${window.$apiEndpoint}/appoiments/fetch-apps-today/${id}`, {
            headers: {
                "x-access-token": cookies.token
            }
        }).then(res => {
            viewApps(res.data)
            const risultati = res.data;
            const prev_imponibile = [];
            const prev_tasse = [];

            //Creo la chiamata per recuperare la somma degli appuntamenti
            const app = risultati.map((item, index) => {
                //Setto le variabili sul map
                const IdAppuntamneto = item[5];

                axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(risposta => {

                    const aliquota_intera = (allSettings.aliquota);
                    const aliquota = (allSettings.aliquota / 100);

                    const imponibile = risposta.data[0].NonPagato;
                    const tasse = (risposta.data[0].NonPagato * aliquota);

                    const imponibile_def = Math.round(imponibile * 100) / 100;
                    const tasse_def = Math.round(tasse * 100) / 100;

                    //Creo un array per imponibile e tasse
                    //Eseguo la preview del totale
                    //Eseguo il push dei risultati in un nuovo array
                    prev_imponibile.push(imponibile_def);
                    prev_tasse.push(tasse_def);

                    //Sommo gli Array
                    var sum_prev_imponibile = prev_imponibile.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_imponibile_2 = Math.round(sum_prev_imponibile * 100) / 100;

                    var sum_prev_tasse = prev_tasse.reduce(function (a, b) {
                        return a + b;
                    }, 0);

                    const sum_prev_tasse_2 = Math.round(sum_prev_tasse * 100) / 100;

                    //Totale preventivo
                    const totaleAllPrev = (sum_prev_imponibile_2 + sum_prev_tasse_2)

                    setPrewImp("Totale Imponibile: " + sum_prev_imponibile_2 + " €")
                    setPrewTasse("Totale Tasse: " + sum_prev_tasse_2 + " €")
                    setPrewAll("Totale Preventivo: " + totaleAllPrev + " €")
                });
            });
        })
    };

    //Bottone genera fattura
    const generaFattura = () => {
        //Verifico che l'arrray si pieno con dei dati se no stampo errore
        if (!Array.isArray(allApps) || !allApps.length) {
            // array does not exist, is not an array, or is empty
            // ⇒ do not attempt to process array
            return (
                setErr1('Appuntamenti non selezionati'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        //Controllo se posso fattura per questo cliente
        axios.get(`${window.$apiEndpoint}/users/fetchData/${selectedOption}`, {
            headers: {
                "x-access-token": cookies.token
            }
        }).then(res => {
            viewCheck(res.data)
        })

        if (checkCostumers === true) {

            //Dati corretti procedo alla fatturazione
            //Funzione per strippare stringa
            function mysql_real_escape_string(str) {
                return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
                    switch (char) {
                        case "\0":
                            return "\\0";
                        case "\x08":
                            return "\\b";
                        case "\x09":
                            return "\\t";
                        case "\x1a":
                            return "\\z";
                        case "\n":
                            return "\\n";
                        case "\r":
                            return "\\r";
                        case "\"":
                        case "'":
                        case "\\":
                        case "%":
                            return "\\" + char; // prepends a backslash to backslash, percent,
                        // and double/single quotes
                    }
                });
            }

            //Recupero aliquota e numero fattura dai settaggi
            const numero_fattura_iniziale = allSettings.numero_fattura;
            const aliquota_intera = (allSettings.aliquota);
            const aliquota = (allSettings.aliquota / 100);
            const descrizione_aliquota = mysql_real_escape_string(allSettings.descrizione_aliquota);
            const descrizione_fattura_norm = normalizeDescription(content) || "Nessuna descrizione";
            const descrizione_fattura_enc = encodeURIComponent(descrizione_fattura_norm);

            //Creo numero di fattura incrementale
            const numero_fattura_incrementale = (numero_fattura_iniziale + 1)

            //Chiedo conferma per proseguire
            const confirmation = window.confirm('Sei sicuro di voler procedere a generare la fattura per il cliente e gli appuntamenti selezionati?')
            if (confirmation === true) {
                const appuntamentiPerfattura = allApps
                //Verifico che l'arrray si pieno con dei dati se no stampo errore
                if (!Array.isArray(allApps) || !allApps.length) {
                    // array does not exist, is not an array, or is empty
                    // ⇒ do not attempt to process array
                    return (
                        setErr1('Appuntamenti non selezionati'),
                        setTimeout(() => { setErr1('') }, 3000)
                    )
                }

                var sumArray = function () {
                    // Use one adding function rather than create a new one each
                    // time sumArray is called
                    function add(a, b) {
                        return a + b;
                    }

                    return function (arr) {
                        return arr.reduce(add);
                    };
                }();

                //Setto un ciclo
                const app = allApps.map((item, index) => {
                    //Setto le variabili sul map
                    const dataGiorno = item[0];
                    const OrarioArrivo = item[1];
                    const OrarioPartenza = item[2];
                    const Tariffa = item[3];
                    const Trattamento = item[4];
                    const IdAppuntamneto = item[5];
                    const CodiceCliente = item[6];

                    const encoded_treatment = encodeURIComponent(Trattamento);

                    //Procedo al'update per gli apputamenti selezionati nel Databse ciclando i risultati presenti nell'array filtrato
                    axios.get(`${window.$apiEndpoint}/invoice/update-app-invoice/${IdAppuntamneto}`, {
                        headers: {
                            "x-access-token": cookies.token
                        }
                    }).then(res => {
                        return (
                            setSucc('Appuntamenti aggiornati con successo'),
                            setTimeout(() => { setSucc('') }, 3000)
                        )
                    })

                    //Eseguo i contteggi dei totali e delle tasse
                    //Recupero costi netti per ogni singolo appuntamento
                    axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                        headers: {
                            "x-access-token": cookies.token
                        }
                    }).then(risposta => {

                        const imponibile = risposta.data[0].NonPagato;
                        const tasse = (risposta.data[0].NonPagato * aliquota);

                        //Setto gl istati per il codice ciente e il numero fattura
                        viewReditectC(CodiceCliente);
                        viewReditectN(numero_fattura_iniziale);

                        //Creo la variabile per l'anno di riferimento sulla fattura selezionata
                        const anno_riferimento_fattura = dataGiorno.replace(/\//g, '').slice(0, -6);
                        setAnnoFattura(anno_riferimento_fattura);

                        //Inserisco nel Databse tutti i dati per la fattura
                        axios.get(`${window.$apiEndpoint}/invoice/insert-app-invoice/${numero_fattura_iniziale}/${imponibile}/${tasse}/${CodiceCliente}/${IdAppuntamneto}/${aliquota_intera}/${dataGiorno}/${encoded_treatment}/${OrarioArrivo}/${OrarioPartenza}/${descrizione_aliquota}/${descrizione_fattura_enc}`, {
                            headers: {
                                "x-access-token": cookies.token
                            }
                        }).then(res => {
                            return (
                                setSucc('Dati fattura aggiornati con successo'),
                                setTimeout(() => { setSucc('') }, 3000)
                            )
                        })

                        //Eseguo update su tabella settings per id fattura
                        axios.get(`${window.$apiEndpoint}/invoice/update-settings-invoice/${numero_fattura_incrementale}`, {
                            headers: {
                                "x-access-token": cookies.token
                            }
                        }).then(res => {
                            return (
                                setSucc('Numero fattura aggiornato con successo'),
                                setTimeout(() => { setSucc('') }, 3000)
                            )
                        })

                        //Eseguo update su tabella settings per id fattura
                        axios.get(`${window.$apiEndpoint}/invoice/update-settings-invoice/${numero_fattura_incrementale}`, {
                            headers: {
                                "x-access-token": cookies.token
                            }
                        }).then(res => {
                            return (
                                setSucc('Numero fattura aggiornato con successo'),
                                setTimeout(() => { setSucc('') }, 3000)
                            )
                        })
                    })
                    //Procedo alla creazione del pdf
                }) //Fine del map
                //Svuoto la tabella
                viewApps([])
                //Esegup il refresh della pagina
                setTimeout(() => { setCreated(true) }, 3000)
            }
        } else {
            //Dati non corretti non eseguo la fatturazione
            setErr1('Per poter procedere nella fatturazione è necessario inserire tutti i dati nel modulo anagrafica, per il cliente selezionato.')
            setSucc('Se avete già inserito i dati nel anagrafica cliente ricliccate sul tasto Fattura!')
            setTimeout(() => { setErr1('') }, 8000)
        }
    };

    //Se lo state isCreated é true eseguo il redirect alla pagina profilo utente
    if (isCreated) {
        // redirect to home if signed up
        return <Redirect to={`/gen-pdf/${allReditectC}/${allReditectN}/${annoFattura}`} />;
        //return window.location.reload();
        //console.log(annoFattura)
    }

    //Bottone tutti
    const generaReport = () => {
        //Verifico che l'arrray si pieno con dei dati se no stampo errore
        if (!Array.isArray(allApps) || !allApps.length) {
            // array does not exist, is not an array, or is empty
            // ⇒ do not attempt to process array
            return (
                setErr1('Appuntamenti non selezionati'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        //Controllo se posso fattura per questo cliente
        axios.get(`${window.$apiEndpoint}/users/fetchData/${selectedOption}`, {
            headers: {
                "x-access-token": cookies.token
            }
        }).then(res => {
            viewCheck(res.data)
        })

        //Disabilito il controllo di tutti i dati per procedere alla fattura
        //if (checkCostumers === true ) {
        //I dati sono presenti
        //Funzione per strippare stringa
        function mysql_real_escape_string(str) {
            return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
                switch (char) {
                    case "\0":
                        return "\\0";
                    case "\x08":
                        return "\\b";
                    case "\x09":
                        return "\\t";
                    case "\x1a":
                        return "\\z";
                    case "\n":
                        return "\\n";
                    case "\r":
                        return "\\r";
                    case "\"":
                    case "'":
                    case "\\":
                    case "%":
                        return "\\" + char; // prepends a backslash to backslash, percent,
                    // and double/single quotes
                }
            });
        }

        //Recupero aliquota e numero fattura dai settaggi

        const numero_fattura_iniziale = allSettings.numero_fattura;
        const aliquota_intera = (allSettings.aliquota);
        const aliquota = (allSettings.aliquota / 100);
        const descrizione_aliquota = mysql_real_escape_string(allSettings.descrizione_aliquota);
        /* const descrizione_report_norm = normalizeDescription(content) || "Nessuna descrizione";
        const descrizione_report_enc = encodeURIComponent(descrizione_report_norm); */

        //Creo numero di fattura incrementale
        const numero_fattura_incrementale = (numero_fattura_iniziale + 1)

        //Chiedo conferma per proseguire
        const confirmation = window.confirm('Sei sicuro di voler procedere nel cacellare gli appuntamenti selezionati, questa opzione cancellerà tutti gli appuntamenti selezionati e procederà a generare un report?')
        if (confirmation === true) {
            const appuntamentiPerfattura = allApps
            //Verifico che l'arrray si pieno con dei dati se no stampo errore
            if (!Array.isArray(allApps) || !allApps.length) {
                // array does not exist, is not an array, or is empty
                // ⇒ do not attempt to process array
                return (
                    setErr1('Appuntamenti non selezionati'),
                    setTimeout(() => { setErr1('') }, 3000)
                )
            }

            var sumArray = function () {
                // Use one adding function rather than create a new one each
                // time sumArray is called
                function add(a, b) {
                    return a + b;
                }

                return function (arr) {
                    return arr.reduce(add);
                };
            }();

            //Setto un ciclo
            const app = allApps.map((item, index) => {
                //Setto le variabili sul map
                const dataGiorno = item[0];
                const OrarioArrivo = item[1];
                const OrarioPartenza = item[2];
                const Tariffa = item[3];
                const Trattamento = item[4];
                const IdAppuntamneto = item[5];
                const CodiceCliente = item[6];

                //Procedo al'update per gli apputamenti selezionati nel Databse ciclando i risultati presenti nell'array filtrato
                axios.get(`${window.$apiEndpoint}/invoice/update-app-invoice-2/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(res => {
                    return (
                        setSucc('Appuntamenti aggiornati con successo'),
                        setTimeout(() => { setSucc('') }, 3000)
                    )
                })

                //Cancello Appuntamento da Google Calendar
                axios.get(`${window.$apiEndpoint}/calendar/delete-event/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(res => {
                    return (
                        setSucc('Appuntamenti cancellato con successo'),
                        setTimeout(() => { setSucc('') }, 3000)
                    )
                })

                //Eseguo i contteggi dei totali e delle tasse
                //Recupero costi netti per ogni singolo appuntamento
                axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(risposta => {
                    const imponibile = risposta.data[0].NonPagato
                    const tasse = (risposta.data[0].NonPagato * aliquota)

                    //Setto gl istati per il codice ciente e il numero fattura
                    viewReditectC(CodiceCliente)
                    viewReditectN(numero_fattura_iniziale)
                    //Creo la variabile per l'anno di riferimento sulla fattura selezionata
                    const anno_riferimento_fattura = dataGiorno.replace(/\//g, '').slice(0, -6);
                    setAnnoFattura(anno_riferimento_fattura)
                    //Inserisco nel Databse tutti i dati per la fattura
                    axios.get(`${window.$apiEndpoint}/invoice/insert-app-report/${numero_fattura_iniziale}/${imponibile}/${tasse}/${CodiceCliente}/${IdAppuntamneto}/${aliquota_intera}/${encodeURIComponent(dataGiorno)}/${encodeURIComponent(Trattamento)}/${encodeURIComponent(OrarioArrivo)}/${encodeURIComponent(OrarioPartenza)}/${encodeURIComponent(descrizione_aliquota)}`, {
                        headers: {
                            "x-access-token": cookies.token
                        }
                    }).then(res => {
                        return (
                            setSucc('Dati report aggiornati con successo...Attendere Prego..'),
                            setTimeout(() => { setSucc('') }, 3000)
                        )
                    })
                })
            }) //Fine del map

            //Procedo a cancellare gli appuntamenti selzionati
            setTimeout(() => {
                axios.delete(`${window.$apiEndpoint}/invoice/delete-app-id`, {
                    headers: {
                        "x-access-token": cookies.token
                    }
                }).then(res => {
                    return (
                        setSucc('Appuntamenti cancellati con successo'),
                        setTimeout(() => { setSucc('') }, 3000)
                    )
                })
                //Svuoto la tabella
                viewApps([])
                //Esegup il refresh della pagina
                setTimeout(() => { setCreated1(true) }, 3000)
            }, 4500)

        }
        /*} else {
    
          //I dati non sono presenti
    
          //Dati non corretti non eseguo la fatturazione
          setErr1('Per poter procedere all generazione del report è necessario inserire tutti i dati nel modulo anagrafica, per il cliente selezionato.')
          setSucc('Se avete già inserito i dati nel anagrafica cliente ricliccate sul tasto Cancella per generare il Report!')
          //Dati
          setTimeout(() => {setErr1('')},8000)
    
        }*/
    };

    //Se lo state isCreated é true eseguo il redirect alla pagina profilo utente
    if (isCreated1) {
        // redirect to home if signed up
        return <Redirect to={`/gen-report/${allReditectC}/${allReditectN}/${annoFattura}`} />;
        //return window.location.reload();
    }

    //Chiamata post per inserimento utente
    const onSubmit = data => {

        setPrewImp('')
        setPrewTasse('')
        setPrewAll('')

        const codice_cliente = selectedOption;
        const startDate = data.startDate;
        const endDate = data.endDate;

        if (!codice_cliente) {
            return (
                setErr1('Cliente non selezionato'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        if (!startDate) {
            return (
                setErr1('Data di arrivo non selezionata'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        if (!endDate) {
            return (
                setErr1('Data di partenza non selezionata'),
                setTimeout(() => { setErr1('') }, 3000)
            )
        }

        axios.post(`${window.$apiEndpoint}/appoiments/fetch-apps-range`, {
            codice_cliente: codice_cliente,
            startDate: startDate,
            endDate: endDate,


        }, {
            headers: {
                'x-access-token': cookies.token
            }
        })
            .then(res => {
                viewApps(res.data)

                const risultati = res.data;

                const prev_imponibile = [];
                const prev_tasse = [];
                //Creo la chiamata per recuperare la somma degli appuntamenti

                const app = risultati.map((item, index) => {
                    //Setto le variabili sul map
                    const IdAppuntamneto = item[5];


                    axios.get(`${window.$apiEndpoint}/invoice/fetch-un-single/${IdAppuntamneto}`, {
                        headers: {
                            "x-access-token": cookies.token
                        }
                    }).then(risposta => {

                        const aliquota_intera = (allSettings.aliquota)
                        const aliquota = (allSettings.aliquota / 100)

                        const imponibile = risposta.data[0].NonPagato
                        const tasse = (risposta.data[0].NonPagato * aliquota)

                        const imponibile_def = Math.round(imponibile * 100) / 100
                        const tasse_def = Math.round(tasse * 100) / 100

                        //Creo un array per imponibile e tasse
                        //Eseguo la preview del totale
                        //Eseguo il push dei risultati in un nuovo array
                        prev_imponibile.push(imponibile_def)
                        prev_tasse.push(tasse_def)

                        //Sommo gli Array
                        var sum_prev_imponibile = prev_imponibile.reduce(function (a, b) {
                            return a + b;
                        }, 0);

                        const sum_prev_imponibile_2 = Math.round(sum_prev_imponibile * 100) / 100

                        var sum_prev_tasse = prev_tasse.reduce(function (a, b) {
                            return a + b;
                        }, 0);

                        const sum_prev_tasse_2 = Math.round(sum_prev_tasse * 100) / 100
                        //Totale preventivo
                        const totaleAllPrev = (sum_prev_imponibile_2 + sum_prev_tasse_2)

                        setPrewImp("Totale Imponibile: " + sum_prev_imponibile_2 + " €")
                        setPrewTasse("Totale Tasse: " + sum_prev_tasse_2 + " €")
                        setPrewAll("Totale Preventivo: " + totaleAllPrev + " €")

                    });
                });
            }).catch(err => {
                setErr1('Errore - ' + err.message)
            })
    }

    return (
        <>
            <ReactTooltip />
            <SectionTitle title="Inserisci" subtitle="Crea nuova fattura" />
            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <div className="card border-left-warning  shadow h-100 py-6 px-4">
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Button className="mt-2 mb-3" data-tip="Per poter fatturare devi aver settato le impostazioni di fattura nell'apposita sezione" variant="info" size="md" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                    <FontAwesomeIcon className="mx-1" icon={faInfo} />
                                </Button>
                                <Form.Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="cliente" >
                                            <Form.Label>Seleziona Cliente:</Form.Label>

                                            {loading ?
                                                <Select value={selectedOption} onChange={handleChange} options={allUsers} />
                                                : <center><Spinner size="sm" animation="border" variant="info" /></center>
                                            }
                                            <pre className="mt-2">Codice Cliente Selezionato: <strong>{selectedOption}</strong> {selectedOptionLabel} </pre>

                                        </Form.Group>
                                    </Col>
                                    <Col className="mb-4">
                                        <center>
                                            <Button data-tip="Seleziona Giorno Corrente" onClick={() => day()} className="mt-4 ml-4" variant="info" size="md" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                                <FontAwesomeIcon className="mx-1" icon={faCalendarDay} /> Giorno
                                            </Button>
                                            <Button data-tip="Seleziona Ultima Settimana" onClick={() => week()} className="mt-4 ml-4" variant="info" size="md" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                                <FontAwesomeIcon className="mx-1" icon={faCalendarWeek} /> Settimana
                                            </Button>
                                            <Button data-tip="Seleziona Ultimi 30 Giorni" onClick={() => mese()} className="mt-4 ml-4" variant="info" size="md" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                                <FontAwesomeIcon className="mx-1" icon={faCalendarDay} /> Mese
                                            </Button>
                                            <Button data-tip="Seleziona Ultimi 365" onClick={() => anno()} className="mt-4 ml-4" variant="info" size="md" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                                <FontAwesomeIcon className="mx-1" icon={faCalendarAlt} />  Anno
                                            </Button>
                                            <Button data-tip="Seleziona tutti gli appuntamenti da saldare" onClick={() => tutti()} className="mt-4 ml-4" variant="info" size="md" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                                <FontAwesomeIcon className="mx-1" icon={faCalendar} />  Tutto
                                            </Button>
                                            <Button variant="info" size="md" type="submit" className="mt-4 ml-4" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                                <FontAwesomeIcon className="mx-1" icon={faSearch} />  Cerca per date
                                            </Button>
                                            <p style={{ marginTop: '2.5vh', fontWeight: 'bold', color: 'red' }}>{showErr1}</p>
                                            <p style={{ marginTop: '2.5vh', fontWeight: 'bold', color: 'green' }}>{showSucc}</p>
                                            <p style={{ marginTop: '2.5vh', fontWeight: 'bold', color: 'grey', fontSize: '1.8vh' }}>{prewImp}</p>
                                            <p style={{ marginTop: '2.5vh', fontWeight: 'bold', color: 'grey', fontSize: '1.8vh' }}>{prewTasse}</p>
                                            <p style={{ marginTop: '2.5vh', fontWeight: 'bold', color: 'black', fontSize: '1.8vh' }}>{prewAll}</p>

                                            <p></p>
                                        </center>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col>
                                        <Form.Group className="mt-2" controlId="startDate" >
                                            <Form.Label>Data di Arrivo</Form.Label>
                                            <Form.Control type="date" name="startDate" ref={register()} />
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group className="mt-2" controlId="endDate" >
                                            <Form.Label>Data di partenza</Form.Label>
                                            <Form.Control type="date" name="endDate" ref={register()} />
                                        </Form.Group>
                                    </Col>
                                </Form.Row>

                                <Form.Row>
                                    <Form.Group controlId="descrizione" as={Col} >
                                        <Form.Label>Descrizione Fattura</Form.Label>
                                        <JoditEditor name="descrizione" value={content} config={config} ref={editor} tabIndex={1} onBlur={newContent => setContent(newContent.target.innerHTML)} onChange={newContent => { }} />
                                    </Form.Group>
                                </Form.Row>

                                {loading ? <MuiThemeProvider theme={theme}>
                                    <MUIDataTable
                                        title={""}
                                        data={allApps}
                                        columns={columns}
                                        options={options}
                                    /></MuiThemeProvider> : <center><Spinner animation="border" /></center>}
                            </Form>

                            <center><Button data-tip="Genera Fattura" className="mt-3" onClick={() => generaFattura()} variant="info" size="lg" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                <FontAwesomeIcon className="mx-1" icon={faFileAlt} />  Fattura
                            </Button>
                                <Button data-tip="Cancella" className="mt-3 ml-2" onClick={() => generaReport()} variant="info" size="lg" style={{ backgroundColor: "#e57373", borderColor: "#e57373", fontWeight: '600' }}>
                                    <FontAwesomeIcon className="mx-1" icon={faWindowClose} />  CANCELLA
                                </Button></center>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default AddInvoice
